import { useSelector } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import styled from "styled-components";

import AdminMain from "@pages/Dashboard/Components/AdminMain";
import { RootEntity, RootState } from "@types-runway/state";
import { User } from "@types-runway/user";

import { adminRoutePaths } from "./adminRoutes";

// The legacy admin keeps its own look (XCUT-R14), so this spacing is not an admin token.
const backLinkSpacingBelow = 16;

const BackToRebuiltAdmin = styled.p`
  margin: 0 0 ${backLinkSpacingBelow}px;
  text-align: right;

  a {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

// What the patient Dashboard mounts at `/dashboard/admin`, the legacy admin's
// address: the legacy admin as before the rebuild (XCUT-R15), for admins only,
// with a link back to the rebuilt admin (XCUT-R22).
const LegacyAdminEntry = () => {
  const user = useSelector<RootState, RootEntity<User>>((state) => state.user);

  // Non-admins never see admin tools, even by address (FIND-R1).
  if (!user.data.isAdmin) {
    return <Redirect to={adminRoutePaths.nonAdminLanding} />;
  }

  return (
    <>
      <BackToRebuiltAdmin>
        <Link to={adminRoutePaths.home}>Back to the new admin</Link>
      </BackToRebuiltAdmin>
      <AdminMain />
    </>
  );
};

export default LegacyAdminEntry;
